import { easClient } from '../../common/client/apollo-client';
import { loader } from 'graphql.macro';
import { trackCustomHeapEvent } from '../../../utils/heap';
import { ErrorMessages } from '../../../utils/errorMessages';
import { AuthenticationMethod } from '../models/digitalidentity';
const getMfaIdentity: any = loader('../../../graphql/queries/get-mfa-identity.graphql');

class GetDigitalIdentity {

  async getIdentity(): Promise<AuthenticationMethod> {
    try {
      const response = await easClient().query({
        query: getMfaIdentity,
        variables: {
        },
        fetchPolicy: 'network-only'
      });
      if (response?.errors?.[0]?.message) {
        throw new Error(response?.errors?.[0]?.message);
      }

      if (!response?.data?.digitalIdentity) {
        throw new Error(ErrorMessages.DOCUMENTS_NOT_FOUND);
      }
      trackCustomHeapEvent('get-mfa-identity-service-success', {});
      return response?.data?.digitalIdentity?.identity?.multifactorAuthenticationMethods?.[0];
    } catch (error) {
      trackCustomHeapEvent('get-mfa-identity-service-error', {});
      throw new Error(ErrorMessages.SERVICE_UNAVAILABLE);
    }
  }
}

export default GetDigitalIdentity;
export const getDigitalIdentity = new GetDigitalIdentity();
